import { route, tag, type PageTour } from '../pageTour';

export const cameraManagementTour: PageTour = {
  id: 'page-camera-management',
  version: 1,
  title: 'Edit Cameras',
  summary: 'Edit cameras\' names, streams and settings in one place.',
  match: route('/camera-management'),
  steps: [
    {
      target: tag('cameras-filters'),
      title: 'Filter cameras',
      description: 'Search by name or narrow the list by group, tag or camera type to find the cameras you want to change.',
      side: 'right',
    },
    {
      target: tag('cameras-view-modes'),
      title: 'List or group tree',
      description: 'Work through cameras as a flat list, or browse them group by group.',
      side: 'bottom',
    },
    {
      target: tag('cameras-import'),
      title: 'Bulk upload',
      description: 'Adding many cameras at once? Upload a CSV or Excel file instead of entering them one by one.',
      side: 'bottom',
      permission: 'cameras.add',
    },
    {
      target: tag('cameras-add'),
      title: 'Add a camera',
      description: 'Add a single camera to the selected site by entering its details.',
      side: 'bottom',
      permission: 'cameras.add',
    },
    {
      target: tag('cameras-content'),
      title: 'Edit your cameras',
      description: 'Use the actions on each row to edit, configure or delete a camera. Tick several rows to change tags or recording settings for all of them at once.',
      side: 'top',
    },
  ],
};
